<script>
    import {APP_PATH, APP_VERSION} from "./lib/constants";
    import Route, {router} from "./lib/Router/Router.svelte";
    import {cookie} from "./lib/cookie";
    import R from "./lib/requests";
    import app from './stores/app';
    import user from "./stores/user";
    import Login from "./components/pages/Login.svelte";
    import AppHeader from "./components/AppHeader.svelte";
    import AppMenu from "./components/AppMenu.svelte";
    import Alert from "./components/Alert.svelte";
    import Notifier from './components/Notifier.svelte';
    import PageLoader from "./components/PageLoader.svelte";
    import PopupLoader from "./components/PopupLoader.svelte";
    import Members from "./members/Members.svelte";
    import MemberEdit from "./members/MemberEdit.svelte";
    import CheckIns from "./checkin/CheckIns.svelte";
    import MemberCheckin from "./checkin/MemberCheckin.svelte";
    import UserCheckin from "./checkin/UserCheckin.svelte";
    import CheckinConfirm from "./checkin/CheckinConfirm.svelte";
    import Hotels from "./hotels/Hotels.svelte";
    import GeneralSettings from "./settings/GeneralSettings.svelte";
    import Users from "./users/Users.svelte";
    import ActionRequests from "./actions/ActionRequests.svelte";
    import TeatroPasses from "./teatro-pass/TeatroPasses.svelte";

    let appInitialized = false;

    const initUser = async () => {
        let coo = cookie.get('enorme-app') || null;
        if (coo) {
            $user.token = coo;
        }
    }

    const appInitialize = () => {
        const onSuccess = result => {
            $user.id = result.user.id;
            $user.role_id = ~~result.user.role_id;
            $user.name = result.user.name;
            $user.email = result.user.email;

            $app.countries = result.countries;

            if (APP_VERSION !== result.app_version) {
                alert("Η έκδοση της εφαρμογής που χρησιμοποιείται είναι πεπερασμένη!\nΚαθαρίστε την προσωρινή μνήμη του browser σας και ανανεώστε αυτή την σελίδα για να χρησιμοποιήσετε την πιο πρόσφατη έκδοση της εφαρμογής.");
            }

            appInitialized = true;
        }

        const onFailure = err => {
        };

        if ($user.token != null && $user.token !== '') {
            R.handle(R.app.initialize, [], onSuccess, onFailure);
        }

    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && $app.escapeEventHandlers.length) {
            $app.escapeEventHandlers[$app.escapeEventHandlers.length - 1]();
        }
    });

    initUser();

    $: {
        if ($user.token != null && !appInitialized) {
            appInitialize();
        }

        if (appInitialized) {
            if (router.url === "/") {
                router.go(`/${APP_PATH}`)();
            }
        }
    }
</script>

{#if window.location.pathname === "/checkin"}
    <CheckinConfirm/>
{:else}
    {#if !$user.token}
        <Login/>
    {:else if appInitialized}
        <PageLoader/>
        <PopupLoader/>
        <AppHeader/>
        <AppMenu/>
        <main>
            <div class="app-main-content">
                <div class="container-fluid">
                    <Route match="/">
                        <Route match="{APP_PATH}">
                            <Route match="members" guard="{ user.isAdmin }">
                                <Members/>
                            </Route>
                            <Route match="new-member" let:router guard="{ user.isAdmin }">
                                <MemberEdit memberId="0"/>
                            </Route>
                            <Route match="member" let:router guard="{ user.isAdmin }">
                                <MemberEdit memberId="{ router.id }"/>
                            </Route>
                            <Route match="checkins">
                                <CheckIns/>
                            </Route>
                            <Route match="member-checkin" let:router guard="{ user.allowCheckins }">
                                <MemberCheckin checkinId="{ router.id }"/>
                            </Route>
                            <Route match="user-checkin" let:router guard="{ user.allowCheckins }">
                                <UserCheckin checkinId="{ router.id }"/>
                            </Route>
                            <Route match="hotels" guard="{ user.isAdmin }">
                                <Hotels/>
                            </Route>
                            <Route match="teatro-passes" guard="{ user.isAdmin }">
                                <TeatroPasses/>
                            </Route>
                            <Route match="settings" guard="{ user.isAdmin }">
                                <GeneralSettings/>
                            </Route>
                            <Route match="users" guard="{ user.isAdmin }">
                                <Users/>
                            </Route>
                            <Route match="action-requests" guard="{ user.isAdmin }">
                                <ActionRequests/>
                            </Route>
                        </Route>
                    </Route>
                </div>
            </div>
        </main>
    {/if}
{/if}
<Alert/>
<Notifier/>

<style>
    main {
        width: 100%;
        padding-top: var(--header-height);
    }

    @media (max-width: 999px) {
        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        main {
            padding-left: 50px;
        }

        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1025px) {
        main {
            padding-left: var(--aside-width);
        }

        main .app-main-content {
            padding: 30px 10px 20px 10px;
        }
    }
</style>